// extracted by mini-css-extract-plugin
export default {"customers":"oL","wrapper":"pL","carousel":"qL","carousel_inner_wrapper":"rL","top_quote":"sL","bottom_quote":"tL","carousel_wrapper":"uL","feedbacks_wrapper":"vL","arrows":"wL","prev":"xL","img":"yL","review_btn":"zL"};
    if(module.hot) {
      // 1713996748322
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  